import { redirect, type RouteObject } from "react-router-dom";

export const slackMessagingRoutes: RouteObject[] = [
  { index: true, loader: () => redirect("/ask-redo?tab=slack") },
  { path: "*", loader: () => redirect("/ask-redo?tab=slack") },
];
